import { FC, useCallback, useContext } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

import { useDictionary } from '@cvt/hooks/useDictionary';

import { TributeCardWizardContext } from '@modules/Tributes/contexts/TributeCardWizardContext';
import { TributeCardDeliveryDetailsForm, FormData } from '@modules/Tributes/components/TributeCardDeliveryDetailsForm';


export const DeliveryDetailsStep: FC = () => {
  const { onNextStep, onPreviousStep, onSetDeliveryDetails, deliveryDetails } = useContext(TributeCardWizardContext);
  const dictionary = useDictionary();

  const onSubmit = useCallback((formData: FormData) => {
    onSetDeliveryDetails(formData);
    onNextStep();
  }, [onNextStep, onSetDeliveryDetails]);

  return (
    <Box>
      <Stack gap={1} alignItems="center" mt={5} mb={4}>
        <Typography variant="h3" fontSize={18} fontWeight={600}>{dictionary.tributes.edit.card.cardDialog.deliveryDetails}</Typography>
        <Typography variant="h6" color="text.secondary" fontSize={16}>
          {dictionary.tributes.edit.card.cardDialog.deliveryDetailsSubtitle}
        </Typography>
      </Stack>
      <Box>
        <TributeCardDeliveryDetailsForm
          onSubmitRequest={onSubmit}
          defaultValues={deliveryDetails || {}}
          slots={{
            footer: (formState) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mt={4}
              >
                <Button
                  variant="outlined"
                  color="default"
                  onClick={onPreviousStep}
                  sx={{
                    px: 3,
                    py: 1,
                  }}
                  startIcon={<ArrowBack />}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{
                    px: 3,
                    py: 1,
                  }}
                  endIcon={<ArrowForward />}
                >
                  Next
                </Button>
              </Stack>
            ),
          }}
        />
      </Box>

    </Box>
  );
};
